import { SVGWrapper } from '../SVGWrapper';

const InformationIcon = SVGWrapper(() => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.22135 10.6038C8.79598 10.6038 10.8831 8.51668 10.8831 5.94205C10.8831 3.36742 8.79598 1.28028 6.22135 1.28027C3.64672 1.28027 1.55957 3.36742 1.55957 5.94205C1.55957 8.51668 3.64672 10.6038 6.22135 10.6038ZM12.002 5.94205C12.002 9.13459 9.41389 11.7227 6.22135 11.7227C3.02881 11.7227 0.440747 9.13459 0.440747 5.94205C0.440747 2.74951 3.02881 0.161449 6.22135 0.161449C9.41389 0.161449 12.002 2.74951 12.002 5.94205ZM6.22135 9.11206C5.91239 9.11206 5.66194 8.8616 5.66194 8.55265L5.66194 5.41993C5.66194 5.11098 5.91239 4.86052 6.22135 4.86052C6.53031 4.86052 6.78076 5.11098 6.78076 5.41993L6.78076 8.55265C6.78076 8.8616 6.5303 9.11206 6.22135 9.11206Z"
        fill="#718096"
      />
      <path
        d="M5.6999 3.85386C5.6999 3.5655 5.93366 3.33174 6.22202 3.33174C6.51038 3.33174 6.74414 3.5655 6.74414 3.85386C6.74414 4.14222 6.51038 4.37598 6.22202 4.37598C5.93366 4.37598 5.6999 4.14222 5.6999 3.85386Z"
        fill="#718096"
      />
    </svg>
  );
});

export default InformationIcon;
